// opportunities.js — BL-048 (ADR-068) client helpers for the user-owned
// "Your Opportunities" dashboard panel.
//
// The server is the authority: get-dashboard-metrics OMITS metrics.opportunities
// entirely when the feature is off for the user, and derives the panel
// EXCLUSIVELY from the server-authoritative investor_opportunities projection
// (never a runtime derive over legacy client BUY rows). These helpers are pure
// selectors/formatters — no fetching, no advice language (signal-not-advice).

export const OPPORTUNITY_FEATURE_KEY = "investor_opportunities_enabled";

/**
 * Select the server-provided opportunities panel, or null when absent (feature
 * off / no payload).
 */
export function selectOpportunities(metrics) {
  return metrics && metrics.opportunities ? metrics.opportunities : null;
}

/**
 * The stable analysis-detail route for an opportunity's originating analysis.
 */
export function analysisRoute(analysisId) {
  return analysisId ? `/my-analyses/${analysisId}` : "/my-analyses";
}

/**
 * The recent-opportunity rows (empty array when the panel is empty/absent).
 */
export function opportunityRows(panel) {
  return panel && Array.isArray(panel.recent) ? panel.recent : [];
}
